export enum AcNatureType {
  ASSET = "Asset",
  LIABILITY = "Liability",
  INCOME = "Income",
  EXPENSE = "Expense",

}
